import { openDB } from "idb";

export const dbPromise = openDB("app-db", 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains("outbox")) {
      db.createObjectStore("outbox", { keyPath: "id" });
    }
    if (!db.objectStoreNames.contains("data")) {
      db.createObjectStore("data", { keyPath: "id" });
    }
  },
});
